export const SUPER_BATCH_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  crashCourse: 'crash_course',
};
